












































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';

//@ts-ignore
import paquetes from '@/mixins/axios/sistema_paquetes'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa
  },
  data() {
    return {
        columnasd:[
             
          
            {
                tag:'descripcion',
                data:'descripcion',
                active:true
            },
             {
                tag:'monto',
                data:'monto',
                active:true
            },
             {
                tag:'total_poas',
                data:'total_poas',
                active:false
            },
             
            {
                tag:'edit',
                data:'edit',
                active:false
            },
             {
                tag:'delete',
                data:'delete',
                active:false
            },
        ],

        id:null as any,
       descripcion:null as any,
       total_poas:'' as any,
      monto:'' as any,
     
         
              paquetes:[] as any,
      
    }
  },
     mixins: [paquetes],
     validations: {
           total_poas: {
      required,
    },
    monto: {
      required,
    },
     
      descripcion: {
      required,
    },
     

   
  },
  methods:{
        
      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_SISTEMA_PAQUETES(row).then(response => {

                    if (response != null) {

 this.paquetes=this.paquetes.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
        this.total_poas=1;
            this.monto=200;
            this.descripcion=""; 
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_paquetes').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.total_poas=row.total_poas;
 this.descripcion=row.descripcion; 
          
 this.monto=row.monto;
 $('#ac_modal_paquetes').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_SISTEMA_PAQUETES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.paquetes.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar paquete, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_SISTEMA_PAQUETES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Paquete modificado correctamente.");
  this.paquetes=this.paquetes.filter(item => item.id !== dat.id);
 this.paquetes.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear paquetes, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
             descripcion:this.descripcion, 
             total_poas:this.total_poas, 
             monto:this.monto, 
           
          
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')
let data= await this.GET_SISTEMA_PAQUETES().then(response => {

                    if (response != null) {
                        //this.plantas = response;
this.paquetes=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
}
  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

